module.exports = __webpack_public_path__ + "86ec3abe57a6e357bd02aea1442dec1e.svg";